import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { Router } from '@angular/router';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { Select } from 'src/app/shared/models/select';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { MatDialog } from '@angular/material/dialog';
import { AgregarEmpresaComponent } from '../agregar-empresa/agregar-empresa.component';
import { LoadListServices } from 'src/app/core/services/load-list.services';

@Component({
  selector: 'app-nuevo-presupuesto',
  templateUrl: './nuevo-presupuesto.component.html',
  styleUrls: ['./nuevo-presupuesto.component.css']
})
export class NuevoPresupuestoComponent implements OnInit {
  listTitulosObras: Select[] = [];
  listCapturaPrecios: Select[] = [];
  listOpcionesIva: Select[] = [];
  listEmpresas: Select[] = [];
  listReemplazarPrecios: Select[] = [];
  todayDate: Date = new Date();

  private route: string;
  private method: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  presupuestoForm: FormGroup;
  disablebutton: boolean = true;
  classFlag: boolean = false;

  constructor(
    private router: Router,
    private dateAdapter: DateAdapter<Date>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private loadListServices: LoadListServices,
    public dialogAgregarEmpresa: MatDialog) {
    this.dateAdapter.setLocale(Constanst.LOCALE_VE);
  }

  ngOnInit() {
  this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    this.presupuestoForm = new FormGroup({
      nombrePresupuesto: new FormControl({ value: '', disabled: true }),
      nombreEmpresa: new FormControl({ value: '', disabled: true }),
      tituloObra: new FormControl({ value: '', disabled: true }),
      capturaPrecios: new FormControl({ value: '', disabled: true }),
      descripcionPresupuesto: new FormControl({ value: '', disabled: true }),
      ubicacionCondicionesValidez: new FormControl({ value: '', disabled: true }),
      contratante: new FormControl({ value: '', disabled: true }),
      numContrato: new FormControl({ value: '', disabled: true }),
      fechaPresupuesto: new FormControl({ value: '', disabled: true }),
      aplicarIva: new FormControl({ value: '', disabled: true }),
      reemplazarPrecios: new FormControl({ value: '', disabled: true }),
      nombreFirmaUno: new FormControl({ value: '', disabled: true }),
      descripcionFirmaUno: new FormControl({ value: '', disabled: true }),
      civFirmaUno: new FormControl({ value: '', disabled: true }),
      nombreFirmaDos: new FormControl({ value: '', disabled: true }),
      descripcionFirmaDos: new FormControl({ value: '', disabled: true }),
      civFirmaDos: new FormControl({ value: '', disabled: true }),
      nombreFirmaTres: new FormControl({ value: '', disabled: true }),
      descripcionFirmaTres: new FormControl({ value: '', disabled: true }),
      civFirmaTres: new FormControl({ value: '', disabled: true }),
      nombreFirmaCuatro: new FormControl({ value: '', disabled: true }),
      descripcionFirmaCuatro: new FormControl({ value: '', disabled: true }),
      civFirmaCuatro: new FormControl({ value: '', disabled: true }),
    });

    this.listTitulosObras = this.loadListServices.getWorksTitlesBudget();
    this.listCapturaPrecios = this.loadListServices.getPriceCaptureBudget();
    this.listOpcionesIva = this.loadListServices.getIvaOptionsBudget();
    this.listReemplazarPrecios = this.loadListServices.getReplacePricesBudget();
    this.getCompanyBudget();
  }

  getCompanyBudget() {
    this.route = '/getAllCompanyBudget';
    this.method = 'GET';
    let data = {};

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {

        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {

          for (let i = 0; i < response.data.length; i++) {
            let company: Select = { id: '', value: '' };
            company.id = (response.data[i].idCompany).toString();
            company.value = response.data[i].companyName;
            this.listEmpresas.push(company);
          }

          if (this.listEmpresas.length > 0) {
            this.presupuestoForm = new FormGroup({
              nombrePresupuesto: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(4), Validators.maxLength(250)]),
              nombreEmpresa: new FormControl({ value: this.listEmpresas[0].id, disabled: true }),
              tituloObra: new FormControl({ value: this.listTitulosObras[0].id, disabled: false }),
              capturaPrecios: new FormControl({ value: this.listCapturaPrecios[0].id, disabled: false }),
              descripcionPresupuesto: new FormControl({ value: '', disabled: false }, [Validators.minLength(10), Validators.maxLength(250)]),
              ubicacionCondicionesValidez: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(50)]),
              contratante: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(4), Validators.maxLength(50)]),
              numContrato: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(14)]),
              fechaPresupuesto: new FormControl({ value: new Date(), disabled: false }),
              aplicarIva: new FormControl({ value: this.listOpcionesIva[0].id, disabled: false }),
              reemplazarPrecios: new FormControl({ value: this.listReemplazarPrecios[0].id, disabled: false }),
              nombreFirmaUno: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(20)]),
              descripcionFirmaUno: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(20)]),
              civFirmaUno: new FormControl({ value: '', disabled: false }, [Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(5), Validators.maxLength(10)]),
              nombreFirmaDos: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(20)]),
              descripcionFirmaDos: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(20)]),
              civFirmaDos: new FormControl({ value: '', disabled: false }, [Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(5), Validators.maxLength(10)]),
              nombreFirmaTres: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(20)]),
              descripcionFirmaTres: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(20)]),
              civFirmaTres: new FormControl({ value: '', disabled: false }, [Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(5), Validators.maxLength(10)]),
              nombreFirmaCuatro: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(20)]),
              descripcionFirmaCuatro: new FormControl({ value: '', disabled: false }, [Validators.minLength(4), Validators.maxLength(20)]),
              civFirmaCuatro: new FormControl({ value: '', disabled: false }, [Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(5), Validators.maxLength(10)]),
            });
            this.disablebutton = false;
            this.apiCallService.hideSpinner();
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_COMPANY_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
          }
        } else {
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GET_COMPANY_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
      });
  }

  onSubmit(): void {
    if (this.presupuestoForm.invalid) {
      return;
    } else {
      return this.confirm();
    }
  }

  confirm() {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_BUDGET, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.route = '/addBudgetUser';
        this.method = 'POST';
        let data = {
          budgetUserEntity: {
            companyBudgetEntity: {
              idCompany: this.presupuestoForm.controls['nombreEmpresa'].value
            },            
            budgetName: this.presupuestoForm.controls['nombrePresupuesto'].value,
            workTittle: this.presupuestoForm.controls['tituloObra'].value,
            catchPrice: this.presupuestoForm.controls['capturaPrecios'].value,
            description: this.presupuestoForm.controls['descripcionPresupuesto'].value,
            location: this.presupuestoForm.controls['ubicacionCondicionesValidez'].value,
            contractor: this.presupuestoForm.controls['contratante'].value,
            contractNumber: this.presupuestoForm.controls['numContrato'].value,
            applyIva: Number(this.presupuestoForm.controls['aplicarIva'].value),
            firstSignedName: this.presupuestoForm.controls['nombreFirmaUno'].value,
            firstSignedDescription: this.presupuestoForm.controls['descripcionFirmaUno'].value,
            firstSignedDocument: this.presupuestoForm.controls['civFirmaUno'].value,
            secondSignedName: this.presupuestoForm.controls['nombreFirmaDos'].value,
            secondSignedDescription: this.presupuestoForm.controls['descripcionFirmaDos'].value,
            secondSignedDocument: this.presupuestoForm.controls['civFirmaDos'].value,
            thirdSignedName: this.presupuestoForm.controls['nombreFirmaTres'].value,
            thirdSignedDescription: this.presupuestoForm.controls['descripcionFirmaTres'].value,
            thirdSignedDocument: this.presupuestoForm.controls['civFirmaTres'].value,
            fourthSignedName: this.presupuestoForm.controls['nombreFirmaCuatro'].value,
            fourthSignedDescription: this.presupuestoForm.controls['descripcionFirmaCuatro'].value,
            fourthSignedDocument: this.presupuestoForm.controls['civFirmaCuatro'].value,
            replacePrices: Number(this.presupuestoForm.controls['reemplazarPrecios'].value)
          },
          budgetDate: this.presupuestoForm.controls['fechaPresupuesto'].value
        }

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(response => {

              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.apiCallService.hideSpinner();
                const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_BUDGET_REGISTERED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
                dialog.afterClosed().subscribe(() => {
                  this.router.navigate(['presupuestos']);
                });
              } else {
                switch (response.data.code) {
                  case 'MSG-013': {
                    this.apiCallService.hideSpinner();
                    this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_LIMIT_BUDGET_BYUSER, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
                    break;
                  } default: {
                    this.apiCallService.hideSpinner();
                    this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_BUDGET_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                    break;
                  }
                }
              }
            },
            error => {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            });

      } else {
        dialog.close(false);
      }
    });
  }

  agregarEmpresa() {
    this.dialogAgregarEmpresa.open(AgregarEmpresaComponent, { width: '40rem' });
  }

  navigateMenu(tag: string) {
    this.router.navigate(['/' + tag]);
  }

}
